import React from 'react'
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion'

const FaqArea = props => {
  return (
    <div className="faq-area pt-100 pb-70">
      <div className="container">
        <div className="section-title text-center">
          <h2>Frequently Asked Questions</h2>
          <p className="margin-auto">{props.description}</p>
        </div>

        <div className="row pt-45">
          <div className="col-lg-6 col-md-12">
            <div className="faq-content">
              <Accordion preExpanded={['a', 'a']}>
                {props.faq1.map((item, index) => (
                  <AccordionItem key={index} uuid={item.uuid}>
                    <AccordionItemHeading>
                      <AccordionItemButton>{item.question}</AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <p>{item.answer}</p>
                    </AccordionItemPanel>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="faq-content">
              <Accordion preExpanded={['a', 'a']}>
                {props.faq2.map((item, index) => (
                  <AccordionItem key={index} uuid={item.uuid}>
                    <AccordionItemHeading>
                      <AccordionItemButton>{item.question}</AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <p>{item.answer}</p>
                    </AccordionItemPanel>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FaqArea
